import { render } from "./TeacherResources.vue?vue&type=template&id=5b5cbbe2"
import script from "./TeacherResources.vue?vue&type=script&lang=js"
export * from "./TeacherResources.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__